module.exports = __webpack_public_path__ + "img/carousel-productos-8.f7e6ac6f.jpg";